import switchToBlog from "@/modules/pe-basic-module/hooks/switchToBlog"
import AttachmentListForm from "@/modules/pe-basic-module/views/attachments/AttachmentListForm"
import DiaryCardForm from "@/modules/pe-basic-module/views/diary/DiaryCardForm"
import DiaryListForm from "@/modules/pe-basic-module/views/diary/DiaryListForm"
import NoMatchView from "@/modules/pe-basic-module/views/NoMatchView"
import getDefEventRoutes from "@/modules/pe-topos-module/components/getDefEventRoutes"
import { IToposStore, useToposStore } from "@/modules/pe-topos-module/data/store"
import { useMainStore } from "@/settings/zustand"
import { isUser } from "@/settings/zustand/user"
import OnlyLoggedInForm from "@libs/basic-view/OnlyLoggedInForm"
import { DEFAULT_404_PROPS } from "@libs/interfaces/dummies"
import { ID } from "@libs/interfaces/layouts"
import SEO from "@libs/layout-app/seo"
import { description, image, land_group_id } from "@libs/layouts"
import { Loading } from "@libs/useful"
import Presentation from "@libs/useful/Presentation"
import { __ } from "@libs/utilities"
import { useEffect } from "react"
import { Outlet, Route, Routes, useParams } from "react-router"
import { IFestival, ILand } from "../../data/interfaces"
import { IFestDataStor, useFestDataStore } from "../../data/store"
import { clearFestival, useFestival } from "../../hooks/festival"
import AboutForm from "../about/AboutForm"
import RateSystemForm from "../about/RateSystemForm"
import AdListForm from "../AdListForm"
import MessagesForm from "../messages/MessagesForm"
import ModerationForm from "../moderation/ModerationForm"
import ProjectForm from "../project/ProjectForm"
import ProjectListForm from "../projectList/ProjectListForm"

/* Protopia Ecosystem component */
export interface IFestivalProps {

}
const Festival = (props: IFestivalProps): JSX.Element => {
    const params = useParams()
    const festId: ID = params.landId || "-1" 
    const festival: IFestival = useFestDataStore((state: IFestDataStor) => state.festival)
    const isLoading = useFestival( true, festId )
    const land: ILand = useFestDataStore((state:IFestDataStor) => state.site )
    const eventRoutes = useToposStore((state: IToposStore) => state.eventRoutes)

    
    useEffect(() => {
        useFestDataStore.setState({ festId })
        useMainStore.setState({landId: festId})
        switchToBlog( festId )
        return () => {
            clearFestival()
        }
    }, [festId]) 
    
    if( isLoading ) return <div className="layout-app-state flex-center">
        <Loading />
    </div> 
    
    const _land_group_id = land_group_id()  
    if(!land.id || ( !!_land_group_id  && land.land_group_id !== _land_group_id)) {
        return <div className="layout-app-state flex-centered">
            <NoMatchView {...DEFAULT_404_PROPS} />
        </div>
    }
    return <>
        <SEO
            title={ land.title }
            description={ land.content || description() }
            image={land.thumbnail || image()}
        />
        <Routes> 
            <Route element={<><Outlet /></>} >     
                <Route path="*" element={<AboutForm {...props} parentMode />} >  
                    <Route path="insert-project" element={<></>} /> 
                    <Route path="reglament" element={<></>} /> 
                </Route>   
                <Route path="rate-system" element={<RateSystemForm  {...props} parentMode />} /> 
                <Route path="members" element={
                    isUser()
                        ?
                        <ProjectListForm  {...props} parentMode />
                        :
                        <OnlyLoggedInForm />
                } /> 
                <Route path="ads/*" element={
                    festival.isAd && isUser()
                        ?
                        <AdListForm  {...props} parentMode />
                        :
                        <OnlyLoggedInForm />
                } /> 
                <Route path="attachments/*" element={
                    festival.isAttachments && isUser()
                        ?
                        <AttachmentListForm  {...props} parentMode />
                        :
                        <OnlyLoggedInForm />
                } /> 
                <Route path="diaries/*" element={
                    festival.isDiary && isUser()
                        ?
                        <DiaryListForm  {...props} parentMode />
                        :
                        <OnlyLoggedInForm />
                } /> 
                <Route path="diary-post/:id/*" element={
                    isUser()
                        ?
                        <DiaryCardForm {...props} parentMode />
                        :
                        <OnlyLoggedInForm />
                } /> 
                <Route path="messages/*" element={ <MessagesForm  parentMode /> } /> 
                <Route path="moderation" element={<ModerationForm  {...props} parentMode />} /> 
                <Route
                    path="project/:id/*"  
                    element={
                        isUser()
                            ?
                            <div className="w-100"> 
                                <ProjectForm  /> 
                            </div>
                            :
                            <OnlyLoggedInForm /> 
                    }
                />
                <Route path="presentation" element={<Presentation />} />
                { getDefEventRoutes( eventRoutes) } 
            </Route>
        </Routes>
        {
            land.archived && 
            <div className="mine-corner-no-verified corner-card-project pe-pennant-dark">
                {__("in archive")}
            </div>
        }            
    </>
}
export default Festival